// extracted by mini-css-extract-plugin
export default {"container":"src-styles-portfolio-__link__container__1fPcS"};